/**
 * Desktop kudago app setup.
 */

// add polyfill for the old browsers
require('./polyfill');

// eslint-disable-next-line import/order
const moment = require('moment');
const { v4: uuidv4 } = require('uuid');
const once = require('emmy/once');
const on = require('emmy/on');
const emit = require('emmy/emit');
const q = require('queried');
const ReactDOM = require('react-dom');
const React = require('react');
const delegate = require('emmy/delegate');
const Swiper = require('swiper');
// eslint-disable-next-line import/order
const kudago = require('./components/kudago');

// setup default language
require('moment/locale/ru');

moment.locale(kudago.language);

// eslint-disable-next-line import/order
const ajax = require('component-ajax');
// eslint-disable-next-line import/order
const SwiperFullscreen = require('swiper-fullscreen');
// eslint-disable-next-line import/order
const ScrollUp = require('scrollup');
// eslint-disable-next-line import/order
const autosize = require('autosize');
// eslint-disable-next-line import/order
const domify = require('domify');
// eslint-disable-next-line import/order
const sample = require('lodash/sample');
// eslint-disable-next-line import/order
const likely = require('ilyabirman-likely');
// eslint-disable-next-line import/order
const dialog = require('dialog-component');
// eslint-disable-next-line import/order
const stickybits = require('stickybits');
// eslint-disable-next-line import/order
const css = require('mucss/css');
const VisitedPages = require('./components/visited-pages');
const EOTDfeed = require('./components/eotd');
const MiniQuestion = require('./components/mini-question');
const Quiz = require('./components/quiz');
const MiniQuiz = require('./components/mini-quiz');
const {
  bindInstagramIframes,
  launchInstagramWidgets,
} = require('./components/instagram-iframe');
const getUserConfig = require('./components/get-user-config');
const {
  roubleToSign,
  animateDOM,
  isSafari,
  showLoginPopup,
  wrapInRaven,
  getIframeSrc,
  sortItemFeaturedItems,
  scrollToEl,
  collapseUncollapseDetails,
  inlineSvg,
  initTabs,
} = require('./components/utils');
const phrases = require('./components/phrases');
const Subscription = require('./components/subscription');
const AdvertButton = require('./components/advert-button');
const PageRating = require('./components/rating');
const CollapseTags = require('./components/collapse-tags');
const Faq = require('./components/faq');
const FlipCard = require('./components/flip-card');
const VotingList = require('./components/award');
const FacetsSpoiler = require('./components/facets-spoiler');
const EventsList = require('./components/events-list');
const _ = require('./components/i18n');
const feedbackFormHendler = require('./components/feedback-form-handler');
const { setQuestSlider, questBooking } = require('./components/quest-schedules');

collapseUncollapseDetails('.post-big-details-schedule', 'tr');

wrapInRaven(() => {
  kudago.user = getUserConfig();

  /* -------------- Replace some neutral elems to links ------------ */

  const { makeLink } = window;
  if (makeLink) {
    q.all('[data-future-href]').forEach((i) => makeLink(i));
  }

  /* ------------------- phrases lang --------------------- */
  phrases.setLocale(kudago.language);

  q.all('.body--votingPage').forEach((feed) => new VotingList(feed));

  /* ------------------- Init respondent_session_id ------------------- */

  let respondent_session_id = null;
  if (localStorage.getItem('respondent_session_id')) {
    respondent_session_id = localStorage.getItem('respondent_session_id');
  } else {
    respondent_session_id = uuidv4();
    localStorage.setItem('respondent_session_id', respondent_session_id);
  }

  /* ------------------- Init quizes ------------------- */
  if (window.quizConfig) {
    q.all('.js-quizStart').forEach((i) => on(i, 'click', () => {
      emit(document.body, 'test-start', null, true);
      q.all('.js-hideForQuiz').forEach((j) => j.setAttribute('hidden', 'hidden'));
    }));
    if (new URLSearchParams(new URL(window.location).search).has('result')) {
      q.all('.js-hideForQuiz').forEach((j) => j.setAttribute('hidden', 'hidden'));
    }

    const container = q('#quiz-container');
    ReactDOM.render(<Quiz config={window.quizConfig} />, container);
  }

  const miniQuestions = document.querySelectorAll('.mini-question-item');

  for (let i = 0; i < miniQuestions.length; i++) {
    const miniQuestion = miniQuestions[i];
    const id = parseInt(miniQuestion.className.match(/\d+/), 10);

    ReactDOM.render(<MiniQuestion id={id} sessionId={respondent_session_id} />, miniQuestion);
  }

  delegate(
    document.body,
    'click',
    '.contentImage-sourceContent',
    (e) => e.stopPropagation(),
  );

  const subscriptionBlock = q('#subscription-block');
  if (subscriptionBlock) {
    const subscribe = new Subscription();
    subscribe.start();
  }

  const showMoreTagButton = q('.collapse-tag-show');
  if (showMoreTagButton) {
    const Collapse = new CollapseTags();
    Collapse.start();
  }

  const faqBlocks = q('.faq-wrapper');
  if (faqBlocks) {
    const FaqEl = new Faq();
    FaqEl.start();
  }

  const flipCardContainer = q('.container-flipcard');
  if (flipCardContainer) {
    const FlipCardObj = new FlipCard();
    FlipCardObj.start();
  }

  const showMoreHarnessButton = q('.harness-show_all');
  if (showMoreHarnessButton) {
    showMoreHarnessButton.addEventListener('click', () => {
      const elementsHide = document.querySelectorAll('.post-harness .harness-item_hide');
      elementsHide.forEach((el) => { el.style.display = 'block'; });
      showMoreHarnessButton.style.display = 'none';
      document.querySelector('.harness_hide').style.display = 'block';
    });
    document.querySelector('.harness_hide').addEventListener('click', () => {
      const elementsHide = document.querySelectorAll('.post-harness .harness-item_hide');
      elementsHide.forEach((el) => { el.style.display = 'none'; });
      document.querySelector('.harness_hide').style.display = 'none';
      showMoreHarnessButton.style.display = 'block';
    });
  }

  document.addEventListener('DOMContentLoaded', startScriptForAdvertButton);

  function startScriptForAdvertButton() {
    const advertButton = q('.advert-button');
    if (advertButton) {
      const AdButton = new AdvertButton();
      AdButton.start();
    }
  }

  // rating

  const pageRating = new PageRating();
  pageRating.start();

  const miniQuizes = document.querySelectorAll('.mini-quiz-item');

  for (let i = 0; i < miniQuizes.length; i++) {
    const miniQuiz = miniQuizes[i];
    const id = parseInt(miniQuiz.className.match(/\d+/), 10);

    ReactDOM.render(<MiniQuiz id={id} sessionId={respondent_session_id} />, miniQuiz);
  }

  /* ------------------------------ Cookie --------------------------------- */
  const cookiePermission = JSON.parse(localStorage.getItem('cookie-permission'));
  const cookieBlock = document.querySelector('.cookie-warning');

  if (!cookiePermission && !!cookieBlock) {
    document.querySelector('.cookie-warning').style.visibility = 'visible';
  }

  if (document.querySelector('.cookie-warning__button')) {
    document.querySelector('.cookie-warning__button').addEventListener('click', () => {
      localStorage.setItem('cookie-permission', true);
      document.querySelector('.cookie-warning').style.visibility = 'hidden';
    });
  }

  /* ------------- safari 'required' attributes validation  ------------- */

  q.all('form').forEach((form) => {
    on(form, 'submit', (e) => {
      const formEl = e.target;

      // comments form contains its own 'required' validation
      const isCommentsForm = formEl.classList.contains('comments-reply');

      if (isSafari(navigator.userAgent) && !isCommentsForm) {
        const isValid = formEl.checkValidity();
        if (isValid) {
          return true;
        }

        alert(_('Fill all the required fields'));
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      return true;
    });
  });

  // --------------------------Make nofollow links
  q.all('[rel=nofollow]').forEach((link) => {
    const dataHref = link.getAttribute('data-href');

    if (!link.href && dataHref) {
      link.href = dataHref;
    }
  });

  /* -------------- Messages deletion ------------- */
  delegate(document.body, 'click', '.messages-close', (e) => {
    const message = e.delegateTarget.closest('.messages-item');
    message.parentNode.removeChild(message);
  });

  /* ----------------------- Staff detection ----------------------------- */
  if (kudago.user.isStaff) {
    document.body.classList.add('body--isStaff');
  }

  /* ----------------------- Update instagram widgets height --------------------------- */
  bindInstagramIframes();
  launchInstagramWidgets();

  /* ----------------------- Comments ------------------------------------ */

  const { Comment } = require('./components/comments');
  const { CommentsList } = require('./components/comments');
  const { CommentsForm } = require('./components/comments');

  // item page comments

  const commentsListEl = q('.comments-list');

  if (commentsListEl) {
    const commentsList = new CommentsList({
      el: commentsListEl,
      initialLoad: true,
    });

    const repliesFormEl = q('#replies-form');
    const repliesForm = new CommentsForm({
      el: repliesFormEl,
      hideOnSubmit: true,
      alert(error) {
        this.showError(this.textarea, error);
      },
    });

    const commentsForm = new CommentsForm({
      el: q('#comments-form'),
      prepend: true,
      commentsList,
      alert(error) {
        this.showError(this.textarea, error);
      },
      validate() {
        // safari doesn't support 'required' attribute
        // so we validate the form by hand
        const ratingContainer = q('.comment-form-rating', this.el);

        if (isSafari(navigator.userAgent) && ratingContainer) {
          const selectedRating = q('[name="rating"]:checked', ratingContainer);

          if (!selectedRating) {
            alert(_('Rate the place, please'));
            return false;
          }
        }

        // use native validator for the rest of the browsers
        return true;
      },
    });

    Comment.setRepliesForm(repliesForm);

    repliesForm.restore();
    commentsForm.restore();
  }

  // profile page comments
  const profileCommentsListEl = q('#profile-comments-list');
  if (profileCommentsListEl) {
    const initProfileComments = function () {
      new CommentsList({
        el: profileCommentsListEl,
      });
    };

    initProfileComments();
    on(document, 'loadPage', initProfileComments);
  }

  /* ----------------------- Comments login ------------------------------------ */
  const commentsLogin = q('.comments-reply-login');
  const commentsSubmit = q('.comments-reply-submit-status');

  if (commentsLogin) {
    const loginLinks = q.all('.social-group-icon-link', commentsLogin);
    loginLinks.forEach((l) => {
      // eslint-disable-next-line no-restricted-globals
      l.setAttribute('href', `${l.getAttribute('href')}?next=${location.pathname}#comments`);
    });
    if (!kudago.user.isAuthenticated) {
      commentsLogin.classList.remove('comments-reply-login-hidden');
    }
  }

  if (commentsSubmit) {
    if (!kudago.user.isAuthenticated) {
      commentsSubmit.classList.toggle('comments-reply-submit-status', 'comments-reply-submit-inactive');
    }
  }

  /* ----------------------- Load user zone --------------------------- */
  const getUserAvatarSrc = () => {
    const userAvatar = q('.user-avatar-image');
    if (userAvatar) {
      const userAvatarSrc = userAvatar.getAttribute('src');
      const commentsFormAvatars = q.all('.comments-profile-image');
      commentsFormAvatars.forEach((a) => a.setAttribute('src', userAvatarSrc));
    }
  };

  {
    const container = q('.user-zone-container');
    if (container) {
      if (kudago.user.isAuthenticated) {
        ajax({
          url: '/widgets/user-zone/',
          success: (html) => {
            container.innerHTML = html;
            getUserAvatarSrc();
          },
        });
      } else {
        document.getElementById('user-zone').removeAttribute('hidden');
      }
    }
  }

  /* ----------------------- Editors choice slider ------------------------------------ */
  const editorsChoiceSlider = q('#editors_choice_slider');
  const editorsChoiceSliderAllowedLocations = ['msk', 'spb', 'ekb', 'kzn', 'nnv'];
  if (editorsChoiceSlider && editorsChoiceSliderAllowedLocations.indexOf(kudago.location) !== -1
      && !kudago.isConvertingPageview
      && !(kudago.page === 'activity' && kudago.tagSlug === 'lifestyle')
  ) {
    editorsChoiceSlider.style.display = 'block';
    const swiperElement = document.getElementById('editors_choice_slider_wrapper');
    new Swiper(swiperElement, {
      loop: true,
      speed: 200,
      slidesPerView: 'auto',
      spaceBetween: 10,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true,
      },
      pagination: {
        el: '.editors-choice-slider-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: q('#editors_choice_slider .nav-right'),
        prevEl: q('#editors_choice_slider .nav-left'),
      },
    });
  }

  /* ----------------------- Single item slider ------------------------------------ */
  const postPreviewEls = q.all('.post-big-preview-slider');
  postPreviewEls.forEach((swiperElement) => {
    // show second and so on images were hidden before slider initialization
    swiperElement.classList.remove('post-big-preview-slider-preloading');
    const swiper = new Swiper(swiperElement, {
      loop: true,
      effect: 'fade',
      speed: 200,
      lazy: {
        loadOnTransitionStart: true,
      },
      navigation: {
        nextEl: q('.swiper-button-next', swiperElement),
        prevEl: q('.swiper-button-prev', swiperElement),
      },
    });

    // fullscreen
    const data = [];
    q.all('.post-big-preview-slide', swiperElement).forEach((item) => {
      if (item.classList.contains('swiper-slide-duplicate')) return;

      const image = q('.post-big-preview-image', item);
      const caption = q('.post-big-preview-caption', item);
      const captionText = caption && caption.innerHTML || '';

      data.push({
        src: image.getAttribute('data-full'),
        title: captionText,
      });
    });

    const fsGallery = new SwiperFullscreen({
      data,
    });

    const fsTriggers = q.all('.swiper-button-fullscreen, .post-big-preview-image', swiperElement);
    fsTriggers.forEach((t) => on(t, 'click', () => {
      fsGallery.show(swiper.activeIndex);
    }));
  });

  /* -------------------------- Site search ----------------------------- */

  // mini search
  const Search = require('./components/search');
  const searchForm = q('#search-form');
  if (searchForm) {
    new Search(searchForm);
  }

  /* ------------- Footer and City cities in other languages hider --------------- */

  q.all('.cities-menu-otherlang').forEach((otherlang) => {
    on(otherlang, 'click', (e) => {
      // FIXME. find elements recursively
      const nextsf = e.target.parentNode.nextElementSibling;
      const nextss = nextsf.nextElementSibling;
      let citiesMenuGroups;

      if (!nextss) {
        citiesMenuGroups = [nextsf];
      } else {
        citiesMenuGroups = [nextsf, nextss];
      }

      citiesMenuGroups.forEach((citiesMenuGroup) => {
        citiesMenuGroup.classList.remove('cities-menu-group-hidden');
      });

      otherlang.setAttribute('hidden', true);
    });
  });

  /* --------------------- Init popups ---------------------------------- */

  // init owner feedback popups
  require('./components/owner-feedback');

  /* Flatpages feedback form */
  feedbackFormHendler();

  /* -------------------------- Hide admin status -------------------------- */
  const adminStatus = q('.admin-status');
  if (adminStatus) {
    const savedAdminStatus = localStorage.getItem('admin-status-hidden');
    if (savedAdminStatus) {
      adminStatus.classList.add('collapsed');
    }

    on(adminStatus, 'click', () => {
      const isAdminStatusHidden = adminStatus.classList.toggle('collapsed');

      if (isAdminStatusHidden) {
        localStorage.setItem('admin-status-hidden', 1);
      } else {
        localStorage.removeItem('admin-status-hidden');
      }
    });
  }

  /* --------------------------- Login dialog ------------------------------- */
  delegate(document.body, 'click', '.login-link', (e) => {
    e.preventDefault();
    showLoginPopup({});
    q('.dialog [data-target="login"]').click();
  });

  delegate(document.body, 'click', '.sign-up-link', (e) => {
    e.preventDefault();
    showLoginPopup({});
  });

  delegate(document.body, 'click', '.authPopup-tab', (e) => {
    const target = e.delegateTarget;
    const popup = target.closest('.authPopup');
    const ACTIVE_CLASS = 'authPopup-tab--active';

    q.all('.authPopup-tab', popup).forEach((i) => i.classList.remove(ACTIVE_CLASS));
    target.classList.add(ACTIVE_CLASS);

    q.all('.authPopup-form', popup).forEach((i) => i.setAttribute('hidden', 'hidden'));
    const targetContent = e.delegateTarget.getAttribute('data-target');
    q(`#auth-form-${targetContent}`, popup).removeAttribute('hidden');
  });

  delegate(document.body, 'click', '.dialog-login .body', (e) => {
    if (e.target === e.delegateTarget) {
      const overlay = q('.overlay');
      if (overlay) {
        overlay.click();
      }
    }
  });

  const { createUrl } = require('./components/feed/core');
  const model = require('./components/feed');
  let isPressed = false;
  Array.from(document.querySelectorAll('.authPopup-longbtn-singup')).slice(-1).forEach((button) => {
    button.style.pointerEvents = 'none';
  });
  let isEmailChanged = false;

  const checkButtonActive = (checkbox = null) => {
    const emailInput = document.querySelectorAll('.authPopup-input-email-singup')[1];
    const checkboxes = Array.from(document.querySelectorAll('.authPopup-checkboxHidden')).slice(-2);
    const button = document.querySelectorAll('.authPopup-button')[2];

    if (!emailInput || !checkboxes || !button) return;

    if (!emailInput.value.length && isEmailChanged) {
      emailInput.classList.add('error');
    } else {
      emailInput.classList.remove('error');
    }

    if (checkbox) {
      if (checkbox.checked) {
        checkbox.classList.remove('error');
      } else {
        checkbox.classList.add('error');
      }
    }

    if (checkboxes.filter((it) => !it.checked).length || !emailInput.value.length) {
      button.classList.add('disabled');
    } else {
      button.classList.remove('disabled');
    }
  };

  delegate(document.body, 'change', '.authPopup-input[name="email"]', () => {
    isEmailChanged = true;
    checkButtonActive();
  });

  delegate(document.body, 'click', '.authPopup-checkboxWrap', (e) => {
    const authForm = e.delegateTarget.closest('.authPopup-form');
    const authFormActionUrl = authForm.getAttribute('action');
    const checkboxes = Array.from(document.querySelectorAll('.authPopup-checkboxHidden')).slice(-2);
    if (e.target.classList.contains('authPopup-checkboxHidden')) {
      checkButtonActive(e.target);
    }
    if (!(authFormActionUrl.split('/').includes('register') && checkboxes.filter((it) => !it.checked).length)) {
      Array.from(document.querySelectorAll('.authPopup-longbtn-singup')).slice(-1).forEach((button) => {
        button.style.pointerEvents = 'all';
      });
    } else {
      Array.from(document.querySelectorAll('.authPopup-longbtn-singup')).slice(-1).forEach((button) => {
        button.style.pointerEvents = 'none';
      });
    }
  });

  delegate(document.body, 'click', '.authPopup-button', (e) => {
    // sometimes we dynamically update open page`s uri (for example - due filtering)
    // so, to generate a redirect link, we need to get it from the current browser address
    e.preventDefault();
    const authForm = e.delegateTarget.closest('.authPopup-form');
    const authFormActionUrl = authForm.getAttribute('action');
    const emailInput = document.querySelectorAll('.authPopup-input-email-singup')[1];
    const checkboxes = Array.from(document.querySelectorAll('.authPopup-checkboxHidden')).slice(-2);

    const checkRequiredFields = authFormActionUrl.split('/').includes('register') && (checkboxes.filter((it) => !it.checked).length || !emailInput.value.length);

    if (!emailInput.value.length) {
      emailInput.classList.add('error');
      isEmailChanged = true;
    } else {
      emailInput.classList.remove('error');
    }

    if (checkboxes.filter((it) => !it.checked).length) {
      checkboxes.filter((it) => !it.checked).forEach((checkbox) => checkbox.classList.add('error'));
    } else {
      checkboxes.forEach((checkbox) => checkbox.classList.remove('error'));
    }

    if (isPressed || checkRequiredFields) return;
    isPressed = true;

    Array.from(document.querySelectorAll('.authPopup-button .login-button-text'))
      .forEach((button) => {
        button.style.display = 'none';
        button.parentNode.style.background = 'transparent';
        button.parentNode.style.cursor = 'unset';
      });

    Array.from(document.querySelectorAll('.authPopup-button .login-button-preloader'))
      .forEach((button) => {
        button.style.display = 'block';
      });

    const nextUrl = encodeURIComponent(
      model ? createUrl(model.state) : document.location.href,
    );

    authForm.setAttribute('action', authFormActionUrl.replace(/(\?next=).*/, `$1${nextUrl}`));
    authForm.submit();
    authForm.addEventListener('submit', () => {
      Array.from(document.querySelectorAll('.authPopup-button .login-button-text'))
        .forEach((button) => {
          button.style.display = 'block';
          button.parentNode.style.background = '#f43741';
          button.parentNode.style.cursor = 'pointer';
        });

      Array.from(document.querySelectorAll('.authPopup-button .login-button-preloader'))
        .forEach((button) => {
          button.style.display = 'none';
        });
    });
  });

  delegate(document.body, 'click', '.authLogout-link, .authPopup-socials a', (e) => {
    // sometimes we dynamically update open page`s uri (for example - due filtering)
    // so, to generate a redirect link, we need to get it from the current browser address
    const linkHref = e.delegateTarget.getAttribute('href');
    const nextUrl = encodeURIComponent(
      model ? createUrl(model.state) : document.location.href,
    );

    e.preventDefault();
    document.location = linkHref.replace(/(\?next=).*/, `$1${nextUrl}`);
  });

  /* --------------------------- Tabs ---------------------------------- */
  initTabs();

  /* --------------------------- Social buttons -------------------- */

  if (!kudago.isConvertingPageview) {
    likely.initiate();
  }

  /* --------------------------- Admin: check noindex -------------------- */

  const noindexMeta = q('meta[content=noindex]');
  if (noindexMeta) {
    const statusEl = q('.admin-status');
    let warningEl = q('.admin-warning');

    if (warningEl) {
      const noindex = _('Besides, noindex is on.');
      warningEl.innerHTML += `<br/>${noindex}`;
    } else if (statusEl) {
      const noindexWarning = _('Noindex is on.');

      warningEl = domify(`
        <div class="admin-warning">
          ${noindexWarning}
        </div>
      `);

      statusEl.parentNode.insertBefore(warningEl, statusEl);
    }
  }

  /* ----------------------------- To-top-button -------------------- */
  const scrollUpText = _('back to top');
  new ScrollUp({
    text: `▲<br><span> ${scrollUpText} </span>`,
  });

  /* ----------------- Likes ------------------------ */
  const { Like, DynamicLike } = require('./components/like');
  delegate(document.body, 'click', '.js-likes', (e) => {
    const like = new Like({
      element: e.delegateTarget,
    });

    like.toggle();
  });
  q.all('.js-dynamic-likes').forEach((i) => new DynamicLike(i));

  /* ------------------ Cinema frames  -------------------- */

  (function () {
    const frames = q.all('.single-content-frame-preview');

    if (!frames.length) return;

    const data = [];

    frames.forEach((frame) => {
      const sourceName = frame.getAttribute('data-source');
      const sourceLink = frame.getAttribute('data-link');
      const sourcePattern = _('Photo by %s');
      let sourceMarkup = '';

      if (sourceLink) {
        const link = _.interpolate(sourcePattern, [`
          <a href="${sourceLink}" target="_blank">
            ${sourceName || sourceLink}
          </a>
        `]);
        sourceMarkup = `
          <div>${link}</div>
        `;
      } else if (sourceName) {
        sourceMarkup = `
          <div>
            ${_.interpolate(sourcePattern, [sourceName])}
          </div>
        `;
      }

      data.push({
        src: frame.href,
        title: `
          ${frame.getAttribute('title')}
          ${sourceMarkup}
        `,
      });
    });

    const fsGallery = new SwiperFullscreen({ data });

    frames.forEach((frame, index) => {
      on(frame, 'click', (e) => {
        e.preventDefault();
        fsGallery.show(index + 1);
      });
    });
  }());

  /* ------------------ Trailers' embedding ------------------------- */
  const trailer = q('.trailer-embed');
  if (trailer) {
    const href = trailer.getAttribute('href');
    const iframeSrc = getIframeSrc(href);
    const trailerVideo = domify(`
      <iframe
        src="${iframeSrc}"
        frameborder="0"
        allowfullscreen="true"
        scrolling="no">
      </iframe>
    `);

    trailer.appendChild(trailerVideo);
  }

  /* ----------- Contests participate button -------------------- */
  const Contest = require('./components/contest');
  const contests = q.all('.contest, .single-contest, .post-contest ,profile-contest');
  contests.forEach((contest) => {
    new Contest({ element: contest });
  });

  /* --------------------- Show entire schedule button ---------------------------- */

  on(q('.post-big-subevents-more-link'), 'click', (e) => {
    e.preventDefault();
    e.currentTarget.parentNode.classList.add('opened');
    e.currentTarget.parentNode.removeChild(e.currentTarget);
  });

  /* --------------------- Cascade layout ---------------------------- */
  const Cascade = require('cascade-layout');
  q.all('.waterfall').forEach((item) => {
    const minWidth = (item.classList.contains('waterfall-narrow')) ? 200 : 300;
    const cascade = new Cascade(item, { minWidth });
    on(document, 'cascade-reflow', () => cascade.reflow());
  });

  q.all('.post img').forEach((img) => {
    on(img, 'load', () => emit('cascade-reflow'));
  });

  /* ------------------------ Countdowns ------------------------------------- */
  const Countdown = require('./components/countdown');
  q.all('.countdown-contest').forEach((element) => {
    const ending = element.getAttribute('data-date-ending') * 1000;
    const countdown = new Countdown(element, {
      date: ending,
    });

    countdown.on('expire', () => {
      element.innerHTML = _('Contest has finished. Winners are being chosen');
    });
  });

  q.all('.countdown-event').forEach((element) => {
    const beginning = element.getAttribute('data-date-beginning') * 1000;
    const ending = element.getAttribute('data-date-ending') * 1000;
    const handleEventFinish = (el) => {
      const expiredText = _('Event has already passed');
      el.classList.add('countdown--expired');
      el.innerHTML = `
        <span class="countdown-note">
          <span class="countdown-noteContent">
            ${expiredText}
          </span>
        </span>
      `;

      // hide buy ticket button in case event has passed
      q.all('.service').forEach((item) => {
        item.setAttribute('hidden', 'true');
      });
    };

    if (beginning && ending) {
      let countdown = new Countdown(element, {
        date: beginning,
      });

      countdown.on('expire', () => {
        q('.countdown-note', element).innerHTML = _('Until the ending');

        countdown = new Countdown(element, {
          date: ending,
        });

        countdown.on('expire', () => handleEventFinish(element));
      });
    } else if (beginning) {
      const countdown = new Countdown(element, {
        date: beginning,
      });

      countdown.on('expire', () => {
        element.innerHTML = _('Event is going');
      });
    } else if (ending) {
      const countdown = new Countdown(element, {
        date: ending,
      });

      countdown.on('expire', () => handleEventFinish(element));
    }
  });

  /* --------- Prevent multiple form submits --------- */

  const forms = q.all('.sign-in-form');
  forms.forEach((form) => {
    on(form, 'submit', () => {
      const buttons = q.all('.add-submit, [type="submit"]', form);
      buttons.forEach((button) => button.setAttribute('disabled', 'disabled'));
    });
  });

  function checkSettingsButton() {
    const checkboxes = Array.from(document.querySelectorAll('.settings-form-checkbox'));
    if (document.querySelector('.sign-in-form__submit')) {
      if (checkboxes.filter((c) => !c.checked).length) {
        document.querySelector('.sign-in-form__submit').style.pointerEvents = 'none';
      } else {
        document.querySelector('.sign-in-form__submit').style.pointerEvents = 'all';
      }
    }
  }

  checkSettingsButton();

  delegate(document.body, 'change', '.settings-form-checkbox', checkSettingsButton);

  /* ----------------- Init all textareas as autosize --------------- */

  autosize(q.all('textarea'));

  /* ----------------- Init spoiler blocks --------------- */
  delegate(document.body, 'click', '.spoiler-link', (e) => {
    const link = e.delegateTarget;
    const spoiler = link.parentNode.parentNode;
    const openClass = 'spoiler-open';
    const cl = spoiler.classList;

    if (cl.contains(openClass)) {
      cl.remove(openClass);
    } else {
      cl.add(openClass);
    }

    // update cascade
    emit(window, 'resize');
  });

  /* ------------------- Movie schedules -------------------- */

  const { initMovieScheduler } = require('./components/movie-scheduler');
  const schedulesContainer = q('.schedule-tables');
  if (schedulesContainer) {
    initMovieScheduler(schedulesContainer);
  }

  /* --------- Dynamic events loading on item page --------- */

  const futureEventsList = q('.post-big-events-future');
  if (futureEventsList) {
    const items = q.all('.events-list-item', futureEventsList);

    new EventsList({
      totalCount: futureEventsList.getAttribute('data-total-count'),
      loadedCount: items.length,
      shownAlready: 10,
      place_id: futureEventsList.getAttribute('data-id'),
      url: '/widgets/future-events/',
      container: futureEventsList,
      loadMoreButton: q('.load-more-button', futureEventsList.parentNode),
      templateDependencies: {
        _,
        roubleToSign,
      },
    });
  }

  /* --------- Long current events list concealment --------- */

  const currentEventsList = q('.post-big-events-current');
  if (currentEventsList) {
    const items = q.all('.events-list-item', currentEventsList);

    new EventsList({
      totalCount: currentEventsList.getAttribute('data-total-count'),
      loadedCount: items.length,
      shownAlready: 10,
      container: currentEventsList,
      loadMoreButton: q('.load-more-button', currentEventsList.parentNode),
    });
  }

  /* --------- special lists/recommendations loading --------- */

  const SpecialWidget = require('./components/special-widgets-loader');
  const specilaWidgetItemContainers = q.all('.single-widget-list');

  specilaWidgetItemContainers.forEach((widget) => {
    new SpecialWidget({
      el: widget,
    });
  });

  /* --------- remove vk sign up | log in --------- */
  if (kudago.page === 'award') {
    const vkButtonsLogIn = document.querySelectorAll('.authPopup-vk');
    if (vkButtonsLogIn.length > 0) {
      vkButtonsLogIn.forEach((button) => {
        button.remove();
      });
    }
  }

  /* --------- converting events loading --------- */

  const ConvertingEventsWidget = require('./components/converting-events-widget-loader');
  const convertingEventsWidgetContainers = q.all('.converting-events-list');

  convertingEventsWidgetContainers.forEach((widget) => {
    new ConvertingEventsWidget({
      el: widget,
    });
  });

  /* --------- converting places loading --------- */

  const ConvertingPlacesWidget = require('./components/converting-places-widget-loader');
  const convertingPlacesWidgetContainers = q.all('.converting-places-list');

  convertingPlacesWidgetContainers.forEach((widget) => {
    new ConvertingPlacesWidget({
      el: widget,
    });
  });

  /* --------- featured items rotation --------- */

  const featuredItemsSlider = q('.featured-slider');

  if (featuredItemsSlider) {
    const featuredItems = q.all('.fs-item', featuredItemsSlider);

    const itemsToShow = sortItemFeaturedItems(featuredItems)
    // we obtain array arrays f. items sorted by position,
    // and then take randomely 1 item from each position to show them
      .map((list) => sample(list));

    itemsToShow.forEach((item) => {
      item.classList.remove('hidden');
    });
  }

  /* -------- Load aside events of the day (events of the week) ------------ */
  {
    const EOTDcontainer = q('.eotw-container');
    if (EOTDcontainer) {
      let eotdId = null;
      if (EOTDcontainer.dataset.eotd_id) {
        eotdId = EOTDcontainer.dataset.eotd_id;
      }
      ReactDOM.render(
        <EOTDfeed location={kudago.location} container={EOTDcontainer} eotdId={eotdId} />,
        EOTDcontainer,
      );
    }
  }

  /* --------- visited pages loading --------- */

  const visitedPagesContainer = q('.visited-pages-container');
  if (visitedPagesContainer) {
    ReactDOM.render(<VisitedPages />, visitedPagesContainer);
  }

  /* -------------- Infinite item feed initial load ------------ */
  const itemFeedContainer = q('.infiniteFeed-container');

  if (itemFeedContainer) {
    const mixNames = kudago && kudago.isItemPage && kudago.itemPageNames;
    if (mixNames.length) {
      const locationSlug = window._metricsConfig.location.slug;
      const feedUrl = mixNames[0] === 'index' ? `/${locationSlug}/` : `/${locationSlug}/${mixNames[0]}/`;
      const ItemFeedLoader = require('./components/item-feed');
      const { Item } = require('./components/feed/item');
      const { FeedLayout, FeedController } = require('./components/feed/feed-layout');
      const infiniteFeedModel = new Item({
        page: {
          originUrl: feedUrl,
        },
      });

      // initialize feed component on item feed after items will be loaded
      const callback = () => {
        new FeedController(
          infiniteFeedModel,
          new FeedLayout(infiniteFeedModel, q('.infiniteFeed-items', itemFeedContainer)),
        );

        const itemFeadLoadmoreButton = q('.load-more-button', itemFeedContainer);
        if (itemFeadLoadmoreButton) {
          const { LoadMoreController, LoadMore } = require('./components/feed/load-more');
          new LoadMoreController(
            infiniteFeedModel,
            new LoadMore(infiniteFeedModel, itemFeadLoadmoreButton),
          );
        }
      };

      new ItemFeedLoader(infiniteFeedModel, itemFeedContainer, feedUrl, [callback]).render();
    }
  }

  /* ------------- rel="noopener" ------------- */
  // see https://jakearchibald.com/2016/performance-benefits-of-rel-noopener/
  q.all('[target="_blank"]').forEach((i) => {
    const currentRel = i.getAttribute('rel') || '';
    i.setAttribute('rel', `${currentRel} noopener`);
  });

  /* ------------- 'Follow' button ------------- */

  const Follow = require('./components/follow');
  q.all('.follow').forEach((i) => new Follow(i));

  /* ------------- External counters ------------- */

  // these counters should be placed before feed initialization
  // that way feed gets already modified markup and we don't have any conflict here
  const {
    sendCountersView,
    bindCountersClick,
  } = require('./components/external-counters');
  bindCountersClick();
  sendCountersView();

  // in case when we need to count special widget items
  // (recommendations, they loading later)
  if (q.all('.special-widget').length || q('.singleWidgets')) {
    once(document, 'special-widgets-loaded', () => {
      sendCountersView();
    });
  }

  require('./components/map-view');

  /* ---------------- Flat filters collapsing ----------- */

  const isMayHolidays = document.body.classList.contains('may-holidays');
  const isSummertime = document.body.classList.contains('summertime');
  if (!isMayHolidays && !isSummertime) {
    q.all('.flat-filters .facet').forEach((facet) => {
      const spoiler = new FacetsSpoiler(facet);
      model.on('update', () => spoiler.render());
    });
  }

  /* ----------------------- Typo users-feedbach init ------------------ */

  const initTypo = require('./components/typo');
  const bodyClassList = document.body.classList;
  if (!bodyClassList.contains('body--tech') && !bodyClassList.contains('body--auth')) {
    initTypo();
  }

  const appendCopyright = require('./components/link-on-us');
  if (!kudago.user.isStaff) {
    on(document.body, 'copy', appendCopyright);
  }

  /* -------------- Add CSRF token to POST forms -------------- */
  const CSRFTokenHandler = require('./components/csrf-handler');

  const csrfHandler = new CSRFTokenHandler();
  csrfHandler.run();

  /* -------------------- Price list order buttons -------------------- */

  q.all('.priceList-button').forEach((button) => {
    on(button, 'click', () => {
      if (document.body.classList.contains('body--priceListPopup')) {
        const formClone = q('#contactForm').cloneNode(true);

        dialog(null, formClone)
          .effect('fade')
          .overlay()
          .fixed()
          .closable()
          .escapable()
          .show();
      } else {
        scrollToEl('#contactForm');
      }

      const item = button.closest('.priceList-item');
      const titleEl = q('.priceList-title', item);
      const title = titleEl.textContent;

      const container = item.closest('.priceList-container');
      const suffix = container.getAttribute('data-location-suffix') || '';

      q.all('#contactForm [name="message"]').forEach((i) => { i.value = `${title} ${suffix}`; });
    });
  });

  /* -------------------- Init dropdowns ----------------------------- */
  require('./components/dropdowns');

  /* ------- Show / hide phone numbers in place and event items -----------*/
  require('./components/multi-addresses');

  /* ------------------ Item page map init ------------------*/
  {
    let map;

    if (window.placeMapProvider == 'yandex') {
      map = new (require('./components/item-map').YandexMap)();
    } else if (window.placeMapProvider == 'google') {
      map = new (require('./components/item-map').GoogleMap)();
    }

    if (map) {
      const mapElement = q('#place-map');
      map.init(mapElement, window.placeAddresses);
    }
  }

  /* ----------------------- Third-party scripts ------------------ */

  /* ----- Init Facebook ----- */
  if (q('.fb-like')) {
    /* eslint-disable */
      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      /* eslint-enable */
  }

  /* eslint-disable */
  // ---------------------------async yandex init
  window.yandexReady = false;
  const t = document.documentElement.firstChild;
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = 'https://an.yandex.ru/system/context.js';
  s.setAttribute('async', 'true');
  t.insertBefore(s, t.firstChild);

  s.onload = function () {
    window.yandexReady = true;
    emit(document, 'yandexReady');
  };

  // --------------------------GooglePlus init
  const po = document.createElement('script');
  po.type = 'text/javascript';
  po.async = true;
  po.src = 'https://apis.google.com/js/plusone.js';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(po, s);

  // -------------------Twitter init
  if (q('.twitter-share-button')) {
    const tws = document.createElement('script');
    tws.type = 'text/javascript';
    tws.src = 'https://platform.twitter.com/widgets.js';
    tws.id = 'twitter-wjs';
    tws.async = true;
    document.body.appendChild(tws);
  }

  // ------------------------yandex direct inserting function
  function initYandexDirect(item) {
    if (window.yandexReady) {
      const targetId = item.querySelector('.yandex-post').getAttribute('id');
      setTimeout(() => {
        Ya.Direct.insertInto(96166, targetId, {
          limit: 4,
          title_font_size: 3,
          favicon: true,
          no_sitelinks: false,
          site_bg_color: 'FFFFFF',
          site_charset: 'utf-8',
          font_size: 1,
          ad_format: 'direct',
          type: '240x400',
          border_type: 'block',
          title_color: 'D31C21',
          url_color: 'B0B7BB',
          text_color: '2f3235',
          hover_color: 'D31C21',
        });
      }, 10);
    } else {
      on(document, 'yandexReady', () => {
        initYandexDirect(item);
      });
    }
  }
  /* eslint-enable */

  /* ---------------- New year test --------------- */

  const NewYearTest = require('./components/ny-test');
  const newYearBlock = q('.nyt');
  if (newYearBlock) {
    new NewYearTest({
      element: newYearBlock,
      questions: window.newYearQuestions,
    });
  }

  /* ----------------------- Tickets ------------------------------------ */
  const TicketManager = require('./components/partners');
  if (q('.service') || q('#ticket-services-dropdown-button-small') || q('#ticket-services-dropdown-button-big')) {
    new TicketManager();
  }

  function clickTicketButton() {
    const dropdownBlock = document.getElementById('ticket-services-list-dropdown');
    const buttons = document.querySelectorAll('.buy-ticket');

    if (dropdownBlock) {
      buttons.forEach((button) => button.classList.add('button-disabled'));
      const labels = dropdownBlock.getElementsByTagName('label');
      document.getElementById('services-dropdown__close').addEventListener('click', () => {
        document.querySelector('body').click();
        buttons.forEach((button) => button.classList.remove('button-disabled'));
      });
      for (let i = 0; i < labels.length; i++) {
        labels[i].addEventListener('click', (event) => {
          const block = event.currentTarget.closest('.pather-radio__block');
          const buttonTicket = block.querySelector('a');
          document.querySelector('.buy-button__block').querySelectorAll('a').forEach((e) => e.remove());
          document.querySelector('.buy-button__block').querySelector('button').style.display = 'none';
          document.querySelector('.buy-button__block').append(buttonTicket.cloneNode(true));
          document.querySelector('.buy-button__block').querySelector('a').style.display = 'block';
        });
        if (labels[i].closest('.pather-radio__block').querySelector('input').checked && !document.querySelector('.buy-button__block').querySelector('a')) {
          const block = labels[i].closest('.pather-radio__block').closest('.pather-radio__block');
          const buttonTicket = block.querySelector('a');
          document.querySelector('.buy-button__block').querySelector('button').style.display = 'none';
          document.querySelector('.buy-button__block').append(buttonTicket.cloneNode(true));
          document.querySelector('.buy-button__block').querySelector('a').style.display = 'block';
        }
      }
    } else {
      buttons.forEach((button) => button.classList.remove('button-disabled'));
    }
  }

  if (q('#ticket-services-dropdown-button-big')) {
    document.getElementById('ticket-services-dropdown-button-big').addEventListener('click', () => {
      setTimeout(() => clickTicketButton());
    });
  }

  if (q('#ticket-services-dropdown-button-small')) {
    document.getElementById('ticket-services-dropdown-button-small').addEventListener('click', () => {
      setTimeout(() => clickTicketButton());
    });
  }

  /* ------------ Premieres list scrolling ------------ */
  q.all('.premieres').forEach((container) => {
    const scrollLeftElem = q('.premieres-scroll-left', container);
    const scrollRightElem = q('.premieres-scroll-right', container);
    const area = q('.premieres-content-scrollable', container);
    const list = q('.premieres-list', container);
    const maxScroll = list.clientWidth - area.clientWidth;
    const threshold = 60;

    on(scrollLeftElem, 'click', () => {
      animateDOM(area, 'scrollLeft', 0);
    });

    on(scrollRightElem, 'click', () => {
      animateDOM(area, 'scrollLeft', maxScroll);
    });

    on(area, 'scroll', () => {
      if (area.scrollLeft > threshold) {
        scrollLeftElem.classList.remove('hidden');
      } else {
        scrollLeftElem.classList.add('hidden');
      }

      if (area.scrollLeft < maxScroll - threshold) {
        scrollRightElem.classList.remove('hidden');
      } else {
        scrollRightElem.classList.add('hidden');
      }
    });
  });
});

/* ----------------------- JS Approve email ------------------------------------ */

const emailBar = q('.approve-email-bar-js');

if (emailBar
  && window.kudago.user
  && window.kudago.user.isAuthenticated
  && !window.kudago.user.isConfirmed) {
  css(emailBar, {
    display: 'block',
  });
}

/* --------------------------- Inline svg images -------------------------------- */
inlineSvg('img.desktop-svg-inject[src$=".svg"]');

/* --------------------------- Quest Schedules -------------------------------- */

setQuestSlider('.questSchedule-content');
questBooking('.questSchedule-card:not(.questSchedule-card--disabled)');

/* ----------------------- JS feedback_form from ajax --------------------------- */

const ownerForm = q('.owner-form');
if (ownerForm) {
  ajax({
    url: '/widgets/user-data/',
    success: (data) => {
      if (data.is_auth) {
        q('#owner-name', ownerForm).value = data.name;
        q('#owner-email', ownerForm).value = data.email;
      }
    },
  });
}

/* ----------------------- Sticky panel on converting events --------------------------- */
stickybits('.navbar--sticky');

const DatePicker = require('./components/datepicker');

if (document.getElementById('react-date-picker')) {
  ReactDOM.render(<DatePicker />, document.getElementById('react-date-picker'));
}
